(function () {
  'use strict';

  var DURATION_MS = 3 * 60 * 60 * 1000; // 3 hours
  var STORAGE_KEY = 'ssb_countdown_end';

  function getEndTime() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var end = parseInt(stored, 10);
        if (end > Date.now()) return end;
      }
    } catch (e) {}
    // No valid stored end — start a fresh 3-hour window
    var newEnd = Date.now() + DURATION_MS;
    try { localStorage.setItem(STORAGE_KEY, String(newEnd)); } catch (e) {}
    return newEnd;
  }

  function pad(n, opts) {
    var s = String(n);
    if (s.length < 2 && opts && opts.timeFormatSingleDigit) {
      return opts.timeFormatSingleDigit + s;
    }
    return s;
  }

  function tick() {
    var opts = window.saleCountdownOptions || {};
    var remaining = getEndTime() - Date.now();

    if (remaining <= 0) {
      // Timer hit zero — reset for another 3 hours
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      remaining = DURATION_MS;
      var newEnd = Date.now() + DURATION_MS;
      try { localStorage.setItem(STORAGE_KEY, String(newEnd)); } catch (e) {}
    }

    var totalSeconds = Math.floor(remaining / 1000);
    var hours   = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var hEl = document.getElementById('sale-countdown-hours');
    var mEl = document.getElementById('sale-countdown-minutes');
    var sEl = document.getElementById('sale-countdown-seconds');
    var dEl = document.getElementById('sale-countdown-days');

    if (hEl) hEl.textContent = pad(hours, opts);
    if (mEl) mEl.textContent = pad(minutes, opts);
    if (sEl) sEl.textContent = pad(seconds, opts);
    // Days hidden per saleCountdownOptions.showDays = false; zero it out if present
    if (dEl) dEl.textContent = opts.zeroValue || '00';

    // Sync label elements if customised in theme editor
    var labelsMap = {
      'hours-label':   opts.hoursLabel   || 'HRS',
      'minutes-label': opts.minutesLabel || 'MIN',
      'seconds-label': opts.secondsLabel || 'SEC',
      'days-label':    opts.daysLabel    || 'DAYS'
    };
    Object.keys(labelsMap).forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.dataset.customised) el.textContent = labelsMap[id];
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    tick();
    setInterval(tick, 1000);
  });
})();